import {
  InfoCard,
  InfoCardVariant,
} from '@monorepo/shared/componentsV2/InfoCard';
import { Anchor, Link } from '@monorepo/shared/componentsV2/Link';
import { edpIncompleteDataErrorProductGuideUrl } from '@monorepo/shared/externalLinks/productGuide';
import { EdpViewResponse } from 'mapistry-shared';
import React from 'react';
import styled, { css } from 'styled-components';

const linkStyles = css`
  font-weight: 700;
  color: inherit;
  text-decoration: underline;
`;

const StyledLink = styled(Link)`
  ${linkStyles}
`;

const StyledAnchor = styled(Anchor)`
  ${linkStyles}
`;

type ViewIncompleteDataMessageProps = {
  className?: string;
  editConfigurationLink?: string;
  view: Pick<
    EdpViewResponse,
    'doesUpstreamUseIncompleteData' | 'doesUseIncompleteData'
  >;
};

export function ViewIncompleteDataMessage({
  className,
  editConfigurationLink,
  view,
}: ViewIncompleteDataMessageProps) {
  if (view.doesUpstreamUseIncompleteData) {
    return (
      <InfoCard className={className} isCompact variant={InfoCardVariant.ERROR}>
        This source contains a calculation error.{' '}
        <StyledAnchor
          href={edpIncompleteDataErrorProductGuideUrl}
          target="_blank"
        >
          How do I fix this?
        </StyledAnchor>
      </InfoCard>
    );
  }

  if (view.doesUseIncompleteData) {
    return (
      <InfoCard className={className} isCompact variant={InfoCardVariant.ERROR}>
        This Report contains a calculation error.
        {editConfigurationLink && (
          <>
            {' '}
            <StyledLink to={editConfigurationLink}>
              Edit configuration
            </StyledLink>
          </>
        )}
      </InfoCard>
    );
  }

  return null;
}
